<template lang="html">
  <li class="navbar-marketplace-menu dropdown nav-item auto">
    <a
      class="nav-link mt-sm-1 px-2"
      href="#"
      id="dropdownMenu2"
      :data-toggle="`${isAuth ? 'dropdown' : 'modal'}`"
      :data-target="`${isAuth ? '' : '#loginModal'}`"
      @click.prevent="pushToDataLayer('User menu', 'My account')"
      aria-haspopup="true"
      aria-expanded="false">
      <span style="position: relative">
        <font-awesome-icon class="d-lg-none menu-icon" :icon="[ 'fas', 'shopping-cart' ]" />
        <NotificationSign :active="isAuth && !!unansweredQuestions" class="d-md-none" right/>
      </span>
      Marketplace
    </a>
    <div
      @click="handleClose"
      ref="accountMenuDropable"
      class="dropdown-menu dropdown-menu-right pt-0" aria-labelledby="dropdownMenu2">
      <template v-for="(item, index) in list">
        <div :key="index" class="d-flex py-0" >
          <BadgeCounter v-if="item.route === 'userQuestions'"
                        style="margin-left: 0.18rem;"
                        :count="unansweredQuestions" />
          <router-link v-if="item.route && (!item.disabled || item.disabled === false)"
                       @click.native="pushToDataLayer('Marketplace menu', `${item.action}`)"
                       :key="index"
                       class="dropdown-item py-2"
                       :style="item.route === 'userQuestions' && !!unansweredQuestions ? 'padding-left: 0.18rem' : 'padding-left: 1.5rem'"
                       :to="{ name: item.route, params: item.params }">
            {{ item.name }}
          </router-link>
          <router-link v-else
            :key="index"
            class="dropdown-item py-2 text-muted"
            :style="item.route === 'userQuestions' && !!unansweredQuestions ? 'padding-left: 0.18rem' : 'padding-left: 1.5rem'"
            to="#"
          >
            <div  data-toggle="modal" data-target="#salesDisabledMessageDialog">
              {{ item.name }}
            </div>
          </router-link>
        </div>
      </template>
    </div>
  </li>
</template>

<script>
import store from '@/store'

export default {
  data: () => ({
    list: [
      {
        name: 'Mis compras',
        route: 'userPurchases',
        params: {},
        action: 'My Purchases'
      },
      {
        name: 'Mis ventas',
        route: 'userSales',
        params: {},
        action: 'My Sales',
        hidden: true
      },
      {
        name: 'Mis publicaciones',
        route: 'userPublications',
        params: {},
        action: 'My publications'
      },
      {
        name: 'Preguntas recibidas',
        route: 'userQuestions',
        params: { tab: 'pendientes' },
        action: 'Questions'
      }
    ]
  }),

  computed: {
    isAuth: () => store.state.user.isAuth || false,

    name: () => store.getters['user/name'],

    unansweredQuestions: () => {
      let count = store.state.user.newUnansweredQuestions || 0
      const pendingQuestions = store.state.user.publicationsPendingQuestions

      pendingQuestions.forEach(p => {
        count += p.questions_answers.length
      })
      return count > 99 ? '99+' : count
    },

    marketplace: () => store.state.user.marketplace,
  },

  methods: {
    logout () {
      return store.dispatch('user/logout')
        .then(() => {
          this.pushToDataLayer('User menu', 'Logout')
          const requiresAuth = this.$route && this.$route.meta.requiresAuth

          if (requiresAuth) this.$router.push({ name: 'home' })
        })
    },

    handleClose (e) {
      this.$emit('close')

      this.$refs.accountMenuDropable.classList.add('hidenow')
      setTimeout(() => {
        const menu = this.$refs.accountMenuDropable
        menu && menu.classList.remove('hidenow')
      }, 500)
    }
  },

  mounted () {
    setTimeout(() => {
      const indexItem = this.list.findIndex(item => item.route == 'userSales')
      this.$set(this.list[indexItem], 'disabled', !this.marketplace);
    }, 1500);
    store.dispatch('user/fetchPendingQuestions')
  }
}
</script>

<style lang="scss">
  @import '../../scss/aspect';
  @import '../../scss/colors';
  @import '../../scss/breakpoints';

  .navbar-marketplace {
    &-menu {
      //a.nav-link {
      //  color: #199348 !important;
      //}
      @media screen and (max-width: map-get($grid-breakpoints, "md")) {
        .dropdown-item {
          & .footer {
            padding-left: 1.5rem;
            padding-top: 0 !important;
          }
        }
      }
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/layout/TheMarketplaceMenu.vue